export const jsonClone = (objData: any) => {
  return JSON.parse(JSON.stringify(objData));
};
